import {Autocomplete, Drawer, Stack, TextField} from "@mui/material";
import {useState} from "react";
import type {BasePayers} from "../../firebase/index.js";
import {addExpense, due, ExpenseModel, getPayerByName, paid, PayerModel, TripModel, updatePayers} from "../../firebase/index.js";
import {useInMemoryTrip} from "../../redux/InMemoryTripReducer.js";
import APXActionButtons from "../../reusables/APXActionButtons.jsx";
import type {BSLProps} from "../../reusables/js/APXBottomSheetLayoutUtils.js";
import useBottomSheet from "../../reusables/js/APXBottomSheetLayoutUtils.js";
import {hideNumberSpinner} from "../../reusables/js/APXCrucialStyles.js";


export default function AddNewExpenseBSL({uid, onClose, payers, totalPersons}: BSLProps & { payers: BasePayers } & { totalPersons: number }) {
	  
	  const [paidByWhom, setPaidByWhom] = useState("");
	  const [paidHowMuch, setPaidHowMuch] = useState(0);
	  const [paidOn, setPaidOn] = useState("");
	  const [paidForWhat, setPaidForWhat] = useState("");
	  
	  const inMemoryTrip: TripModel = useInMemoryTrip();
	  
	  const {isOpen, handleOpen, handleClose} = useBottomSheet({initialState: true, onClose});
	  
	  const handleCancel = () => {
			 onClose();
	  };
	  
	  const handleAdd = () => {
			 if (/*FALSY->*/ !!!uid) {
					alert("Please login to add new expense");
					return;
			 }
			 if (paidByWhom.trim() === "" || paidHowMuch <= 0 || paidOn.trim() === "" || paidForWhat.trim() === "") {
					alert("Please fill all the fields");
					return;
			 }
			 
			 const expense = new ExpenseModel(paidByWhom.trim(), paidHowMuch, new Date(paidOn).getTime(), paidForWhat.trim(), false);
			 
			 paid(getPayerByName(payers, paidByWhom.trim()), paidHowMuch);
			 due(payers, paidByWhom.trim(), totalPersons, paidHowMuch);
			 
			 addExpense(uid, inMemoryTrip.expenditureKey, expense.expenseKey, expense);
			 updatePayers(uid, inMemoryTrip.expenditureKey, payers);
			 
			 handleCancel();
			 
	  };
	  
	  
	  return (
				 <Drawer anchor="bottom" open={isOpen} onClose={handleClose} variant="temporary">
						<Stack spacing={2} p={2}>
							  <Stack direction={{xs: "column", sm: "row"}} spacing={2}>
									 <Autocomplete sx={{ml: 1, width: {xs: "100%", sm: "20%"}}}
														clearOnEscape={false}
														disableClearable
														options={Object.values(payers).filter((payer: PayerModel) => /*NOT->*/ !payer.isFrozen).map((payer: PayerModel) => payer.name)}
														renderInput={(params) => (
																  <TextField {...params} required label={"Paid by whom"} variant="outlined"
																				 inputProps={{...params.inputProps, readOnly: true}}/>
														)}
														value={paidByWhom}
														onChange={(event, newValue) => setPaidByWhom(newValue)}
									 />
									 <TextField
												fullWidth
												required
												variant="outlined"
												type={"number"}
												InputProps={hideNumberSpinner}
												label={"Paid how much"}
												value={paidHowMuch}
												onChange={(event) => setPaidHowMuch(Number(event.target.value))}
									 />
									 <TextField
												fullWidth
												required
												variant="outlined"
												type="date"
												label={"Paid on"}
												value={paidOn}
												InputLabelProps={{shrink: true}}
												InputProps={{
													  inputProps:
																 {
																		min: inMemoryTrip.getCreatedAtDate().toISOString().split("T")[0],
																		max: new Date().toISOString().split("T")[0]
																 }
												}}
												onChange={(event) => setPaidOn(event.target.value)}
									 />
									 <TextField
												fullWidth
												required
												variant="outlined"
												label={"Paid for what"}
												value={paidForWhat}
												onChange={(event) => setPaidForWhat(event.target.value)}
									 />
							  </Stack>
							  <APXActionButtons onCancel={handleCancel} onAdd={handleAdd}
													  shouldShowConfirmationDialog={true}
													  validationProviderAllStateFields={[paidByWhom, paidHowMuch, paidOn, paidForWhat]}
							  />
						</Stack>
				 </Drawer>
	  );
}